'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsxFileName = 'src/components/Snippet.js';
exports.default = Snippet;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Highlighter = require('./Highlighter');

var _Highlighter2 = _interopRequireDefault(_Highlighter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Snippet(props) {
  return _react2.default.createElement(_Highlighter2.default, _extends({ highlightProperty: '_snippetResult' }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    }
  }));
}

Snippet.propTypes = {
  hit: _react2.default.PropTypes.object.isRequired,
  attributeName: _react2.default.PropTypes.string.isRequired,
  highlight: _react2.default.PropTypes.func.isRequired
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Snippet, 'Snippet', 'src/components/Snippet.js');
}();

;


//////////////////
// WEBPACK FOOTER
// /tmp/~/react-instantsearch/src/components/Snippet.js
// module id = 1171
// module chunks = 0